<template>
    <v-container fluid v-if="commessa">
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Commessa {{ commessa.numero }} <span class="text-medium-emphasis">— prog.
                        {{ commessa.progressivo }}</span></h2>
            </v-col>
            <v-col v-if="isAdmin" cols="auto">
                <v-btn icon variant="text" size="small" @click="apriDialogCommessa" title="Modifica commessa">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-card variant="outlined" class="mb-4">
            <v-card-text>
                <v-row dense>
                    <v-col cols="6" sm="3">
                        <div class="text-caption text-medium-emphasis">Cliente</div>
                        <div>{{ commessa.cliente }}</div>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <div class="text-caption text-medium-emphasis">Data</div>
                        <div>{{ formattaData(commessa.data) }}</div>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <div class="text-caption text-medium-emphasis">Lotto</div>
                        <div>{{ commessa.lotto || '—' }}</div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h3 class="text-subtitle-1">Posizioni</h3>
            </v-col>
            <v-spacer />
            <v-col v-if="isAdmin" cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialogPosizione(null)">Nuova
                    posizione</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headersPosizioni" :items="posizioni" :items-per-page="25" density="compact">
            <template #[`item.disegno`]="{}">
                <div class="disegno-placeholder d-flex align-center justify-center">
                    <v-icon size="18" color="grey">mdi-image-off-outline</v-icon>
                </div>
            </template>
            <template #[`item.uw`]="{}">
                <v-img :src="uwPlaceholder" width="20" height="30" />
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialogPosizione(item)"
                    :title="isAdmin ? 'Modifica' : 'Visualizza'">
                    <v-icon>{{ isAdmin ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Dialog modifica dati commessa -->
        <v-dialog v-model="dialogCommessa" max-width="600" :fullscreen="isMobile">
            <v-card>
                <v-card-title>Modifica commessa</v-card-title>
                <v-card-text>
                    <v-form ref="formCommessaRef">
                        <v-text-field v-model="formCommessa.numero" label="Numero commessa"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="formCommessa.cliente" label="Cliente"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model="formCommessa.data" label="Data" type="date" />
                        <v-text-field v-model="formCommessa.lotto" label="Lotto" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogCommessa = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvandoCommessa" @click="salvaCommessa">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog visualizza/modifica posizione -->
        <v-dialog v-model="dialogPosizione" max-width="900" :fullscreen="isMobile">
            <v-card>
                <v-card-title>
                    {{ posizioneCorrente.id ? `Posizione ${posizioneCorrente.rif}` : 'Nuova posizione' }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <!-- Riquadro riservato alla futura anteprima del disegno (percorso restituito
                                 da una DLL non ancora integrata). -->
                            <div class="disegno-box d-flex flex-column align-center justify-center">
                                <v-icon size="40" color="grey">mdi-image-off-outline</v-icon>
                                <span class="text-caption text-medium-emphasis mt-2">Anteprima disegno non
                                    disponibile</span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="8">
                            <v-form ref="formPosizioneRef" :disabled="!isAdmin">
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-autocomplete v-model="formPosizione.progettoId" :items="progettiConLabel"
                                            item-title="label" item-value="id" label="Progetto"
                                            :rules="[v => !!v || 'Obbligatorio']"
                                            @update:model-value="onProgettoCambiato" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field :model-value="pfSelezionato" label="P/F" readonly />
                                    </v-col>
                                </v-row>
                                <v-text-field v-model="formPosizione.descrizione" label="Descrizione"
                                    :rules="[v => !!v || 'Obbligatorio']" />
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field v-model.number="formPosizione.qta" type="number" label="Qta"
                                            :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field v-model.number="formPosizione.battenti" type="number"
                                            label="Battenti (BATT)" @update:model-value="onBattentiCambiato" />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field v-model.number="formPosizione.hMan" type="number"
                                            label="H. Maniglia (mm)" />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select v-model="formPosizione.aperturaId" :items="aperturePerPosizione"
                                            item-title="descrizione" item-value="id" label="Apertura" clearable
                                            :no-data-text="progettoSelezionato ? 'Nessuna apertura per questa tipologia/battenti' : 'Seleziona prima il progetto'" />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.l" type="number" step="0.1"
                                            label="L (mm)" :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.h" type="number" step="0.1"
                                            label="H (mm)" :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.spessore" type="number"
                                            step="0.1" label="Spessore (mm)" />
                                    </v-col>
                                </v-row>

                                <v-select v-model="formPosizione.tipoDisegnoId" :items="tipiDisegno"
                                    item-title="descrizione" item-value="id" label="Tipo disegno" clearable
                                    @update:model-value="onTipoDisegnoCambiato" />
                                <v-row v-if="parametriDelTipo.length" dense>
                                    <v-col v-for="p in parametriDelTipo" :key="p.id" cols="6">
                                        <v-text-field v-model.number="parametriValori[p.id]" type="number" step="0.1"
                                            :label="p.etichetta" />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogPosizione = false">{{ isAdmin ? 'Annulla' : 'Chiudi'
                    }}</v-btn>
                    <v-btn v-if="isAdmin" color="primary" :loading="salvandoPosizione"
                        @click="salvaPosizione">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import uwPlaceholder from "@/assets/uw-rating-placeholder.svg";

export default {
    name: "CommessaDettaglioPage",

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            uwPlaceholder,
            dialogCommessa: false,
            salvandoCommessa: false,
            formCommessa: this.formCommessaVuoto(),
            dialogPosizione: false,
            salvandoPosizione: false,
            posizioneCorrente: {},
            formPosizione: this.formPosizioneVuoto(),
            // Valori dei parametri geometrici del tipo disegno scelto, tenuti a parte
            // (mappa parametroDisegnoId -> valore) perché il set di campi è dinamico.
            parametriValori: {},
            headersPosizioni: [
                { title: "Rif", key: "rif", width: 70 },
                { title: "Progetto", key: "codProgetto" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Qta", key: "qta" },
                { title: "P/F", key: "pf" },
                { title: "BATT", key: "battenti" },
                { title: "H.Man", key: "hMan" },
                { title: "Apertura", key: "aperturaDescrizione" },
                { title: "L", key: "l" },
                { title: "H", key: "h" },
                { title: "Spess.", key: "spessore" },
                { title: "", key: "disegno", sortable: false, width: 60 },
                { title: "Uw", key: "uw", sortable: false, width: 50 },
                { title: "", key: "azioni", sortable: false, width: 60 },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        commessa() {
            return this.$store.getters["commesse/corrente"];
        },
        posizioni() {
            return this.$store.getters["commesse/posizioni"];
        },
        isAdmin() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },

        progetti() {
            return this.$store.getters["progetti/lista"];
        },
        // v-autocomplete ha bisogno di un'etichetta testuale unica per voce.
        progettiConLabel() {
            return this.progetti.map(p => ({ ...p, label: `${p.codProgetto} — ${p.descrizione}` }));
        },
        tipiDisegno() {
            return this.$store.getters["tipiDisegno/lista"];
        },
        tutteLeAperture() {
            return this.$store.getters["aperture/lista"];
        },

        progettoSelezionato() {
            return this.progetti.find(p => p.id === this.formPosizione.progettoId) || null;
        },
        pfSelezionato() {
            return this.progettoSelezionato ? this.progettoSelezionato.pf : "";
        },
        // Solo le aperture coerenti con la tipologia del progetto scelto e il numero
        // di battenti impostato in posizione.
        aperturePerPosizione() {
            if (!this.progettoSelezionato) return [];
            return this.tutteLeAperture.filter(a =>
                a.tipoSerramentoId === this.progettoSelezionato.tipoSerramentoId &&
                a.numBattenti === this.formPosizione.battenti);
        },
        tipoDisegnoSelezionato() {
            return this.tipiDisegno.find(t => t.id === this.formPosizione.tipoDisegnoId) || null;
        },
        parametriDelTipo() {
            return this.tipoDisegnoSelezionato ? this.tipoDisegnoSelezionato.parametri : [];
        },
    },

    mounted() {
        this.carica();
        this.$store.dispatch("progetti/carica");
        this.$store.dispatch("tipiDisegno/carica");
        this.$store.dispatch("aperture/carica");
    },

    methods: {
        carica() {
            this.$store.dispatch("commesse/caricaDettaglio", this.id);
            this.$store.dispatch("commesse/caricaPosizioni", this.id);
        },

        formattaData(iso) {
            return iso ? new Date(iso).toLocaleDateString("it-IT") : "—";
        },

        formCommessaVuoto() {
            return { numero: "", cliente: "", data: "", lotto: "" };
        },

        apriDialogCommessa() {
            this.formCommessa = {
                numero: this.commessa.numero,
                cliente: this.commessa.cliente,
                data: this.commessa.data ? this.commessa.data.substring(0, 10) : "",
                lotto: this.commessa.lotto || "",
            };
            this.dialogCommessa = true;
        },

        async salvaCommessa() {
            if (!this.$refs.formCommessaRef.validate()) return;
            this.salvandoCommessa = true;
            try {
                await this.$store.dispatch("commesse/aggiorna", { id: this.id, dati: this.formCommessa });
                this.dialogCommessa = false;
            } catch (error) {
                console.log(error);
            }
            this.salvandoCommessa = false;
        },

        formPosizioneVuoto() {
            return {
                progettoId: null, descrizione: "", qta: 1, battenti: 1, hMan: null,
                aperturaId: null, l: null, h: null, spessore: null, tipoDisegnoId: null,
            };
        },

        // Precompila descrizione e battenti col default del progetto scelto: restano
        // comunque modificabili dall'utente dopo la selezione.
        onProgettoCambiato(progettoId) {
            const p = this.progetti.find(x => x.id === progettoId);
            if (p) {
                this.formPosizione.descrizione = p.descrizione;
                this.formPosizione.battenti = p.numBattenti;
            }
            this.formPosizione.aperturaId = null;
        },

        onBattentiCambiato() {
            this.formPosizione.aperturaId = null;
        },

        onTipoDisegnoCambiato() {
            this.parametriValori = {};
        },

        apriDialogPosizione(item) {
            this.posizioneCorrente = item || {};
            if (item) {
                this.formPosizione = {
                    progettoId: item.progettoId,
                    descrizione: item.descrizione || "",
                    qta: item.qta,
                    battenti: item.battenti,
                    hMan: item.hMan,
                    aperturaId: item.aperturaId,
                    l: item.l,
                    h: item.h,
                    spessore: item.spessore,
                    tipoDisegnoId: item.tipoDisegnoId,
                };
                this.parametriValori = Object.fromEntries(
                    (item.parametriDisegno || []).map(pd => [pd.parametroDisegnoId, pd.valore]));
            } else {
                this.formPosizione = this.formPosizioneVuoto();
                this.parametriValori = {};
            }
            this.dialogPosizione = true;
        },

        async salvaPosizione() {
            if (!this.$refs.formPosizioneRef.validate()) return;
            this.salvandoPosizione = true;
            try {
                const dati = {
                    ...this.formPosizione,
                    parametriDisegno: this.parametriDelTipo.map(p => ({
                        parametroDisegnoId: p.id,
                        valore: Number(this.parametriValori[p.id]) || 0,
                    })),
                };
                if (this.posizioneCorrente.id) {
                    await this.$store.dispatch("commesse/aggiornaPosizione", {
                        commessaId: this.id, id: this.posizioneCorrente.id, dati,
                    });
                } else {
                    await this.$store.dispatch("commesse/creaPosizione", {
                        commessaId: this.id, dati,
                    });
                }
                this.dialogPosizione = false;
            } catch (error) {
                console.log(error);
            }
            this.salvandoPosizione = false;
        },
    },
};
</script>

<style scoped>
.disegno-placeholder {
    width: 36px;
    height: 36px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
}

.disegno-box {
    width: 100%;
    min-height: 180px;
    background: rgba(0, 0, 0, 0.04);
    border: 1px dashed rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 16px;
    text-align: center;
}
</style>
